import { render } from "./modelAndHero.vue?vue&type=template&id=66188d24&lang=true"
import script from "./modelAndHero.vue?vue&type=script&lang=js"
export * from "./modelAndHero.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__